import { useRef } from 'react';

/*
  useDebouncedFn: Hook to provide a render-stable debounced version
  of the passed function

  Does not (yet) support "leading" debounce option

  Returns: debounced function
*/

export function useDebouncedFn(
  // TODO: Fix this the next time the file is edited.
  // oxlint-disable-next-line typescript/no-explicit-any
  fn: (...args: any[]) => any,
  delay: number,
) {
  const timeout = useRef(null);

  const inner = (...args: unknown[]) => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    // @ts-expect-error TS(2322): Type 'Timeout' is not assignable to type 'null'.
    timeout.current = setTimeout(() => fn(...args), delay);
  };

  return inner;
}
